import Rpi from "../sports/common/rpi";

const mapRpi = (jsonObj) => {
    return Object.assign(new Rpi(), jsonObj);
};

export default mapRpi;
